import { HOST } from "../constants/HostConstants";
import { fetchWithRetry } from "../utils/apiRetry";

export const commentCreate = async (
  property_id,
  comment,
  setComments,
  { setWaitingMessage = null } = {}
) => {
  try {
    const res = await fetchWithRetry(
      `${HOST}/api/comment/commentCreate`,
      {
        method: "POST",
        body: JSON.stringify({ property_id, comment }),
        credentials: "include",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      },
      {
        maxRetries: 3,
        initialDelay: 3000,
        onWaiting: (isWaiting, message) => {
          if (setWaitingMessage) {
            setWaitingMessage(isWaiting ? message : null);
          }
        },
      }
    );

    const data = await res.json();

    if (!res.ok) {
      return { success: false, error: data.error || "Failed to post comment" };
    }

    if (setComments) setComments(data);
    return { success: true, data };
  } catch (err) {
return {
      success: false,
      error: "Network error. Server may be starting up - please try again.",
    };
  }
};
